import React, { useState } from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './Form.scss';

const Form = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const formHeading = data.helpSection.formHeading;
  const nameField = data.helpSection.form.nameFiled;
  const emailField = data.helpSection.form.emailField;
  const commentField = data.helpSection.form.commentField;
  const formButtomText = data.helpSection.form.buttonText;

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submissionStatus, setSubmissionStatus] = useState('');

  // Function to handle form field changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  // Function to validate form fields
  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name.trim()) {
      newErrors.name = 'Please enter a valid name';
      valid = false;
    } else {
      newErrors.name = '';
    }

    if (!formData.email.trim() || !emailPattern.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
      valid = false;
    } else {
      newErrors.email = '';
    }

    if (!formData.message.trim()) { // Validate comment field
      newErrors.message = 'Please enter a message';
      valid = false;
    } else {
      newErrors.message = '';
    }

    setErrors(newErrors);
    return valid;
  };
  
   // Function to handle form submission
   const handleSubmit = () => {
    if (validateForm()) {
      const formDataWithPlatform = new FormData();
      formDataWithPlatform.append('name', formData.name);
      formDataWithPlatform.append('email', formData.email);
      formDataWithPlatform.append('message', formData.message);
      formDataWithPlatform.append('platform', 'JLR');
      formDataWithPlatform.append('phone_number', '12345');
  
      const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzA5NDQ5NjE0LCJqdGkiOiI3MTFkMmM1ZTFiOTQ0MDZlOWRlYTRlNTI4NTQ1YjhmZiIsInVzZXJfaWQiOjg0fQ.vopkXvsmll8Vo3GP0O5rOjysblj3HItWHdWPRJ4vT_Y';
  
      fetch('https://tenant.focalx.ai/api/v1/customer/contact/', {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json', // This line is commented out because it's not needed for FormData
          'Authorization': `Bearer ${token}`
        },
        body: formDataWithPlatform, // Changed from data to body
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then((data) => {
        console.error('Error submitting form:', data);
        // console.log('API Response:', data);
        setTimeout(() => {
          setSubmissionStatus('success');
          setFormData({
            name: '',
            email: '',
            message: '',
          });
        }, 1000);
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
      });
    }
  };
  
  
  return (
    <>
      <div className="form-container">
              <h3>{formHeading}</h3>
              <div className="custom-card form">
                <div className="form-group pt-0">
                  <div className="field">
                      <div className="form-control-wrap">
                          <input 
                            type="text" 
                            className="form-control" 
                            id="name" placeholder={nameField}
                            value={formData.name}
                            onChange={handleChange}  
                          />
                          <span className="error-msg text-danger">{errors.name}</span>
                      </div>                    
                  </div>
                </div>
                <div className="form-group">
                  <div className="field">
                      <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        placeholder={emailField}
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <span className="error-msg text-danger">{errors.email}</span>
                      </div>                    
                  </div>
                </div>
                <div className="form-group">
                  <div className="field">
                      <div className="form-control-wrap">
                      <textarea
                        type="text"
                        className="form-control"
                        id="message"
                        placeholder={commentField}
                        value={formData.message}
                        onChange={handleChange}
                      />
                      <span className="error-msg text-danger">{errors.message}</span>
                      </div>                    
                  </div>
                </div>
                <div className="action-btn-wrap">
                    <button
                      id="contact-submit"
                      type="button"
                      className="custom-btn custom-btn-primary"
                      onClick={handleSubmit}
                    >
                      {formButtomText}
                    </button>
                </div>
                {submissionStatus === 'success' && (
                  <div className="thank-you-message">
                    Thank you for your submission!
                  </div>
                )}
              </div>
            </div>
    </>
  );
};

export default Form;
